export const DEFAULT_STEP = 1000;
export const DEFAULT_MIN = 0;
export const DEFAULT_MAX = 3000000;
export const URL_PARAMETER_MIN = 'salePriceFrom';
export const URL_PARAMETER_MAX = 'salePriceTo';



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/ListingFiltersPrice/constants.js